<template>
  <!-- 业务每期详情列表 无支付 -->
  <div class="app-container">
    <div class="title">
      <van-icon name="label-o" color="orange" />
      {{ htbh }}
    </div>
    <div class="items">
      <div class="my-box" v-for="item in list" :key="item.id">
        <div class="line1" :style="{ color: hkztColorFormatter(item.hkzt) }">
          <div class="number">
            <van-icon
              name="award-o"
              :color="hkztColorFormatter(item.hkzt)"
              class="my-icon"
              size="24"
            />
            <span style="font-weight: 600">第{{ item.qs }}期</span>
          </div>
        </div>
        <div class="my-box-con-small">
          <div
            class="my-box-text-small"
            :style="{ 'background-color': hkztColorFormatter(item.hkzt) }"
          >
            {{ hkztFormatter(item.hkzt) }}
          </div>
        </div>
        <div class="line2" style="border-top: none">
          <div class="line2_item">
            <van-icon
              name="clock-o"
              color="LightSkyBlue"
              class="my-icon"
              size="18"
            />
            还款时间
          </div>
          <div class="line2_item">
            {{ item.hkrq }}
          </div>
        </div>
        <div class="line2">
          <div class="line2_item">
            <van-icon
              name="refund-o"
              color="#99cc66"
              class="my-icon"
              size="18"
            />
            计划应还金额
          </div>
          <div class="line2_item">
            {{ item.yhje }}
          </div>
        </div>
        <div class="line2">
          <div class="line2_item">
            <van-icon
              name="after-sale"
              color="orange"
              class="my-icon"
              size="18"
            />
            <span style="margin-right: 5px">实际待还金额</span>
          </div>

          <div class="line2_item">
            {{ item.shje }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon } from "vant";
import { queryRepayInfo } from "@/api/repay-info.js";
import { hkztFormatter, hkztColorFormatter } from "@/utils/formatter.js";
import { getWXCodeOrToRegister } from "@/utils/login.js";
export default {
  name: "RepayInfo",
  //import引入的组件需要注入到对象中才能使用
  components: {
    [Icon.name]: Icon
  },
  data() {
    return {
      leaseId: this.$route.params.leaseId,
      htbh: this.$route.params.htbh,
      list: [],
      total: 0
    };
  },
  created() {
    console.log("RepayInfo.vue created");
    console.log(window.location.href);
    console.log(this.leaseId);
    getWXCodeOrToRegister(this.$route, this.queryRepayInfo);
    // this.queryRepayInfo();
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    queryRepayInfo() {
      queryRepayInfo(this.leaseId)
        .then(response => {
          console.log(response);
          if (response.data.code === 200) {
            this.list = response.data.results.data;
            this.total = response.data.results.total;
            if (this.total === 0) {
              this.$toast.fail("无还款信息");
            }
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
    hkztFormatter(hkzt) {
      return hkztFormatter(hkzt);
    },
    hkztColorFormatter(hkzt) {
      return hkztColorFormatter(hkzt);
    }
  },
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.app-container {
  width: 100%;
  color: rgba(0, 0, 0, 0.5);
}
.my-icon {
  line-height: inherit;
  padding-right: 4px;
}
.title {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: white;
  color: black;
  padding: 6px 0;
  font-size: 18px;
  width: 96%;
  margin: 0 2%;
  margin-bottom: 5px;
  letter-spacing: 4px;
}
.items {
  width: 96%;
  margin: 0 2%;
}
.line1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  // margin-bottom: 10px;
  font-size: 18px;
  border-bottom: 2px solid;
  padding-bottom: 10px;
}
.line2 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-size: 16px;
  padding: 10px 0 10px 0;
  border-top: 1px solid #dadada5c;
  color: #646566;
}
.number {
  display: flex;
  flex-direction: row;
  align-items: center;
  // color: rgba(0, 0, 0, 0.8);
  color: currentColor;
}
.line2_item {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
